// extracted by mini-css-extract-plugin
export var backgroundImage = "_8-1";
export var container = "_8-0";
export var title = "_8-2";